import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function AtendenteMesas() {
  const [mesas, setMesas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [funcionario, setFuncionario] = useState(null);
  const [modalNovaComanda, setModalNovaComanda] = useState(null);
  const [nomeCliente, setNomeCliente] = useState('');
  const navigate = useNavigate();

  const token = localStorage.getItem('funcionario_token');
  const api = axios.create({
    baseURL: `${API_URL}/api`,
    headers: { Authorization: `Bearer ${token}` }
  });

  useEffect(() => {
    if (!token) return navigate('/atendente/login');
    const dados = localStorage.getItem('funcionario_dados');
    if (dados) setFuncionario(JSON.parse(dados));
    carregar();
    const interval = setInterval(carregar, 15000);
    return () => clearInterval(interval);
  }, []);

  const carregar = async () => {
    try {
      const r = await api.get('/mesas');
      setMesas(r.data);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem('funcionario_token');
        navigate('/atendente/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const abrirComanda = async (mesaId) => {
    try {
      const r = await api.post('/comandas', { mesa_id: mesaId, nome_cliente: nomeCliente || null });
      navigate(`/atendente/comanda/${r.data.id}`);
    } catch (err) {
      if (err.response?.data?.comanda_id) {
        navigate(`/atendente/comanda/${err.response.data.comanda_id}`);
      } else {
        alert(err.response?.data?.error || 'Erro ao abrir comanda');
      }
    }
  };

  const clickMesa = (m) => {
    if (m.comanda_aberta_id) {
      navigate(`/atendente/comanda/${m.comanda_aberta_id}`);
    } else {
      setModalNovaComanda(m);
      setNomeCliente('');
    }
  };

  const sair = () => {
    localStorage.removeItem('funcionario_token');
    localStorage.removeItem('funcionario_dados');
    navigate('/atendente/login');
  };

  const tempoAberta = (dt) => {
    if (!dt) return '';
    const diff = Math.floor((Date.now() - new Date(dt)) / 60000);
    if (diff < 60) return `${diff}min`;
    return `${Math.floor(diff / 60)}h${diff % 60}min`;
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#fff' }}>Carregando...</div>;

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#1a0000,#0a0a0a)', paddingBottom: 40 }}>
      {/* Header */}
      <div style={{
        background: 'rgba(0,0,0,0.5)', padding: '14px 16px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        borderBottom: '1px solid #333'
      }}>
        <div>
          <div style={{ fontSize: 12, color: '#999' }}>Atendente</div>
          <div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>👤 {funcionario?.nome || '...'}</div>
        </div>
        <button onClick={sair} style={{
          background: 'rgba(230,57,70,0.2)', border: '1px solid rgba(230,57,70,0.4)',
          color: '#ff6b7a', padding: '6px 12px', borderRadius: 6, fontSize: 12, cursor: 'pointer'
        }}>Sair</button>
      </div>

      <div style={{ padding: 16 }}>
        <h1 style={{ color: '#fff', fontSize: 22, fontWeight: 800, marginBottom: 4 }}>🍽️ Mesas</h1>
        <p style={{ color: '#999', fontSize: 13, marginBottom: 20 }}>Toque numa mesa pra abrir/gerenciar comanda</p>

        {/* Legenda */}
        <div style={{ display: 'flex', gap: 12, marginBottom: 16, fontSize: 11, color: '#aaa' }}>
          <div><span style={{ display: 'inline-block', width: 10, height: 10, background: '#22c55e', borderRadius: '50%', marginRight: 4 }}></span>Livre</div>
          <div><span style={{ display: 'inline-block', width: 10, height: 10, background: '#ef4444', borderRadius: '50%', marginRight: 4 }}></span>Ocupada</div>
        </div>

        {/* Grid de mesas */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12 }}>
          {mesas.map(m => {
            const ocupada = !!m.comanda_aberta_id;
            return (
              <div key={m.id} onClick={() => clickMesa(m)} style={{
                background: ocupada
                  ? 'linear-gradient(135deg, #7f1d1d, #450a0a)'
                  : 'linear-gradient(135deg, #14532d, #052e16)',
                border: `2px solid ${ocupada ? '#ef4444' : '#22c55e'}`,
                borderRadius: 12, padding: 16, cursor: 'pointer',
                textAlign: 'center', minHeight: 130,
                display: 'flex', flexDirection: 'column', justifyContent: 'center',
                transition: 'transform .15s'
              }}>
                <div style={{ fontSize: 34, marginBottom: 4 }}>{ocupada ? '🔴' : '🟢'}</div>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 4 }}>
                  {m.numero.match(/^\d+$/) ? `Mesa ${m.numero}` : m.numero}
                </div>
                {ocupada ? (
                  <>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#fca5a5' }}>
                      R$ {parseFloat(m.comanda_total || 0).toFixed(2).replace('.', ',')}
                    </div>
                    <div style={{ fontSize: 10, color: '#fecaca', marginTop: 2 }}>
                      há {tempoAberta(m.aberta_em)}
                    </div>
                  </>
                ) : (
                  <div style={{ fontSize: 11, color: '#86efac' }}>Livre</div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Modal abrir comanda */}
      {modalNovaComanda && (
        <div onClick={() => setModalNovaComanda(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 100
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#1a1a1a', borderRadius: 12, padding: 24, maxWidth: 380, width: '100%',
            border: '1px solid #333'
          }}>
            <h2 style={{ color: '#fff', fontSize: 18, marginBottom: 6 }}>
              Abrir {modalNovaComanda.numero.match(/^\d+$/) ? `Mesa ${modalNovaComanda.numero}` : modalNovaComanda.numero}
            </h2>
            <p style={{ color: '#999', fontSize: 13, marginBottom: 16 }}>Nome do cliente (opcional):</p>
            <input value={nomeCliente} onChange={e => setNomeCliente(e.target.value)} autoFocus
              placeholder="Ex: João"
              style={{
                width: '100%', padding: 12, background: '#222',
                border: '1px solid #333', color: '#fff', borderRadius: 8,
                fontSize: 14, marginBottom: 16
              }} />
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setModalNovaComanda(null)} style={{
                flex: 1, padding: 12, background: '#333', border: 'none',
                color: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: 14
              }}>Cancelar</button>
              <button onClick={() => { abrirComanda(modalNovaComanda.id); setModalNovaComanda(null); }} style={{
                flex: 1, padding: 12, background: 'linear-gradient(90deg,#e63946,#FF6B00)',
                border: 'none', color: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 700
              }}>Abrir Comanda</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
